import {
  PostFeedbackRequestDto,
  Product,
  Topic,
  UserFeedbackCommandApi
} from '@src/Api/generated-user-feedback';
import { makeAutoObservable } from 'mobx';
import { IStatusApi, defaultStatusApi } from '../DUMEvents/DUMEvents.type';

export interface IUserFeedbackStore {
  status: IStatusApi;
  saveFeedback: (
    _api: UserFeedbackCommandApi,
    values: {
      platform: string;
      topic: string;
      message: string;
      captchaToken: string | null;
    }
  ) => void;
  _api: UserFeedbackCommandApi | undefined;
  onRetry: () => void;
}

export class UserFeedbackStore implements IUserFeedbackStore {
  status = { ...defaultStatusApi, isLoading: false } as IStatusApi;
  private savedForm: {
    platform: string;
    topic: string;
    message: string;
    captchaToken: string | null;
  } = {
    platform: '',
    topic: '',
    message: '',
    captchaToken: null
  };
  _api: UserFeedbackCommandApi | undefined;
  constructor() {
    makeAutoObservable(this);
  }
  async saveFeedback(
    api: UserFeedbackCommandApi,
    value: {
      platform: string;
      topic: string;
      message: string;
      captchaToken: string | null;
    }
  ) {
    if (!this._api) {
      this._api = api;
    }
    try {
      this.status.isLoading = true;
      this.savedForm = value;
      const formValue = {
        ...value,
        product: value.platform.replace(/ /g, '') as Product,
        topic: value.topic.replace(/ /g, '') as Topic,
        description: value.message
      } as PostFeedbackRequestDto;
      const res = await this._api.feedbackPost(undefined, formValue);
      if (res.status === 200) {
        this.status = {
          isSuccess: true,
          isLoading: false,
          isError: false,
          message: ''
        };
      }
    } catch (err) {
      if (err instanceof Error) {
        const checkErr = `${err}`.includes('undefined')
          ? 'Error, Something went wrong. Please refresh or try again later'
          : err;

        this.status = {
          isSuccess: false,
          isLoading: false,
          isError: true,
          message: `${checkErr}`
        };
      }
    }
  }

  onRetry() {
    if (this._api) {
      this.saveFeedback(this._api, this.savedForm);
    }
  }
}

export const UserFeedbackStoreDefault: IUserFeedbackStore = {
  status: {
    isLoading: true,
    isError: false,
    isSuccess: false,
    message: ''
  },
  _api: undefined,
  saveFeedback: () => {
    //
  },
  onRetry: () => {
    //
  }
};
